import React from 'react';
import './ErrorBoundary.css';
import { sendTicket } from '../../services/argosService';
import { auth } from '../../firebaseConfig';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null, 
            errorInfo: null,
            reporting: false,
            reported: false,
            reportError: null,
            ticketId: null
        };
    }

    static getDerivedStateFromError(error) {
        // Atualiza o state para que a próxima renderização mostre a UI alternativa.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Você também pode registrar o erro em um serviço de relatório de erros
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    handleReload = () => {
        window.location.reload();
    };

    handleReportError = async () => {
        const { error, errorInfo } = this.state;
        if (!error) return;

        this.setState({ reporting: true, reportError: null });

        try {
            const currentUser = auth.currentUser;
            const userEmail = currentUser ? currentUser.email : 'anonimo@mago.com';
            
            const titulo = `Crash no Front-end Mago: ${error.toString().substring(0, 100)}`;
            const stackTrace = `${error.toString()}\n\nComponent Stack:\n${errorInfo ? errorInfo.componentStack : 'Não disponível'}`;
            
            const res = await sendTicket({
                titulo,
                descricao: `Ocorreu um erro fatal que travou a renderização da página no cliente.`,
                prioridade: 'alta',
                origem: `Crash Screen (URL: ${window.location.href})`,
                metadata: {
                    ambiente: 'producao',
                    versao: '1.4.2',
                    usuario_afetado: userEmail,
                    stack_trace: stackTrace
                }
            });

            this.setState({ reported: true, reporting: false, ticketId: res.id || 'N/A' });
        } catch (err) {
            console.error("Erro ao reportar crash para o suporte:", err);
            this.setState({ reporting: false, reportError: err.message || 'Erro ao conectar com o servidor.' });
        }
    };

    render() {
        if (this.state.hasError) {
            // Você pode renderizar qualquer UI alternativa
            return (
                <div className="error-boundary-container">
                    <div className="error-boundary-content">
                        <h1 className="error-title">Ops! Algo deu errado.</h1>
                        <p className="error-message">
                            Ocorreu um erro inesperado na aplicação. Você pode tentar recarregar a página ou reportar o erro diretamente ao suporte técnico.
                        </p>
                        
                        <details className="error-details">
                            <summary>Ver detalhes técnicos</summary>
                            <pre>{this.state.error && this.state.error.toString()}</pre>
                            <pre>{this.state.errorInfo && this.state.errorInfo.componentStack}</pre>
                        </details>
                        
                        <div className="error-actions">
                            <button className="reload-button" onClick={this.handleReload}>
                                Recarregar Página
                            </button>

                            {this.state.reported ? (
                                <div className="report-success-box animate-fade-in">
                                    <span className="success-icon">✓</span>
                                    <p>Registrado no Suporte Técnico! Ticket ID: <strong>{this.state.ticketId}</strong></p>
                                </div>
                            ) : (
                                <div className="report-actions-container">
                                    <button 
                                        className="report-button" 
                                        onClick={this.handleReportError}
                                        disabled={this.state.reporting}
                                    >
                                        {this.state.reporting ? 'Enviando ao suporte...' : 'Reportar ao Suporte Técnico'}
                                    </button>
                                    {this.state.reportError && (
                                        <p className="report-error-msg">Falha ao reportar: {this.state.reportError}</p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
